import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth')({
  head: () => ({
    meta: [{ title: 'Tekst' }],
  }),
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <div className="flex h-screen justify-center items-center grid-container">
      <Outlet />
    </div>
  );
}
